export default {
  remote: 'simplify_hub_api_key_manager_mfe',
  name: 'mcp-setup',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: {
    localhost: 'http://localhost:4333/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1100769639/simplify-api-key-manager/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1100769639/simplify-api-key-manager/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1100769639/simplify-api-key-manager/v1/mf2/mf-manifest.json',
  },
};
